import {
  GET_PROGRAM_PENDING,
  GET_PROGRAM_SUCCESS,
  GET_PROGRAM_FAILED,
  GET_PROGRAMS_PENDING,
  GET_PROGRAMS_SUCCESS,
  GET_PROGRAMS_FAILED,
  GET_HOMEPAGE_PROGRAMS_PENDING,
  GET_HOMEPAGE_PROGRAMS_SUCCESS,
  GET_HOMEPAGE_PROGRAMS_FAILED,
} from "consts/actions"

import cleanHomePrograms from "helpers/program"
import formatterHelper from "helpers/formatter"
import stateHelper from "helpers/state"
import localStorageHelper from "helpers/localStorage"

import consts from "consts"

export function get() {
  return {
    accessTokenRequired: false,
    request: {
      url: consts.endpoints.programs,
      method: "GET",
    },
    onStart() {
      return {
        type: GET_HOMEPAGE_PROGRAMS_PENDING,
      }
    },
    onSuccess(payload) {
      return {
        type: GET_HOMEPAGE_PROGRAMS_SUCCESS,
        payload,
      }
    },
    onError(payload) {
      return {
        type: GET_HOMEPAGE_PROGRAMS_FAILED,
        payload: stateHelper.errorPayload(payload.error.user_message),
      }
    },
  }
}

export function getProgram(channelId, programId) {
  return (dispatch, getState) => {
    const id = `${programId}-${channelId}`
    const { programs } = getState()

    const accessToken = localStorageHelper.getSession()?.auth?.access_token
    const baseUrl = formatterHelper.basic(consts.endpoints.program, { channelId, programId })
    const getProgramUrl = accessToken ? `${baseUrl}?access_token=${accessToken}` : baseUrl

    if (programs.pending) {
      return
    }

    return dispatch({
      accessTokenRequired: false,
      request: {
        url: getProgramUrl,
        method: "GET",
      },
      onStart() {
        return {
          type: GET_PROGRAM_PENDING,
          id,
        }
      },
      onSuccess(payload) {
        return {
          type: GET_PROGRAM_SUCCESS,
          id,
          payload,
        }
      },
      onError(payload, meta) {
        return {
          type: GET_PROGRAM_FAILED,
          id,
          payload: stateHelper.errorPayload(payload.user_message, meta.httpCode),
        }
      },
    })
  }
}

export function fetchHomePrograms() {
  return {
    accessTokenRequired: false,
    request: {
      url: consts.endpoints.seoHome,
      method: "GET",
    },
    processResponse: cleanHomePrograms,
    onStart: (payload, meta, dispatch) => {
      dispatch({
        type: GET_PROGRAMS_PENDING,
      })
    },
    onSuccess: (payload, meta, dispatch) => {
      dispatch({
        type: GET_PROGRAMS_SUCCESS,
        payload,
      })
    },
    onError: (payload, meta, dispatch) => {
      dispatch({
        type: GET_PROGRAMS_FAILED,
        payload: stateHelper.errorPayload(payload.user_message, meta.httpCode),
      })
    },
  }
}
